import React from "react";
import ReactDOM from "react-dom/client"; 
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./Store/store"; 
import App from "./App";
import axios from 'axios';
import "./index.css";
import { BrowserRouter } from "react-router-dom";

axios.interceptors.request.use(function (config) {
  const token = store.getState();
  
  if (token.isAuthenticated)
    config.headers.Authorization = `Bearer ${token.AccessToken}`;
  else
    config.headers.Authorization = null;

  return config;
});

const root = ReactDOM.createRoot(document.getElementById("root")); // Use createRoot
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>  {/* Newly added for disabling context menu*/}
        <App />
      </BrowserRouter>
    </PersistGate>
  </Provider>
);